<div class="container-fluid">
	<section>
		<header>
			<h1><span jhiTranslate="ontology-manager.title"></span>&nbsp;
				<jhi-help-link [helpKey]="HELP_MANAGE_ONTOLOGIES"></jhi-help-link>
			</h1>
		</header>
		<nav>
			<ul class="nav nav-tabs">
				<li class="nav-item pe-1 mt-1">
					<a [routerLinkActive]="['active']" [routerLink]="['variables-pane']" class="nav-link p-2" jhiTranslate="ontology-manager.tab.variables"
					   queryParamsHandling="merge"></a>
				</li>
				<li class="nav-item pe-1 mt-1">
					<a [routerLinkActive]="['active']" [routerLink]="['properties-pane']" class="nav-link p-2" jhiTranslate="ontology-manager.tab.properties"
					   queryParamsHandling="merge"></a>
				</li>
				<li class="nav-item pe-1 mt-1">
					<a [routerLinkActive]="['active']" [routerLink]="['methods-pane']" class="nav-link p-2" jhiTranslate="ontology-manager.tab.methods"
					   queryParamsHandling="merge"></a>
				</li>
				<li class="nav-item pe-1 mt-1">
					<a [routerLinkActive]="['active']" [routerLink]="['scales-pane']" class="nav-link p-2" jhiTranslate="ontology-manager.tab.scales"
					   queryParamsHandling="merge"></a>
				</li>
			</ul>
		</nav>
		<div class="tab-content p-3">
			<router-outlet></router-outlet>
			<router-outlet name="popup"></router-outlet>
		</div>
	</section>
</div>
